// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".component-data .title-section {\n  padding-bottom: 0.5rem;\n  font-weight: bold;\n  border-bottom: 1px solid black;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.component-data .title-section .mdc-button {\n  width: 80px;\n}\n.component-data .slot-content {\n  padding-top: 0.5rem;\n}\n.component-data .minimized-content {\n  padding-top: 1rem;\n  display: flex;\n  flex-direction: column;\n}", ""]);
// Exports
module.exports = exports;
